<div class="min-h-screen bg-gray-50/50 p-6 md:p-12 md:pt-2 font-sans">

    <!-- Header Section -->
    <div class="max-w-7xl mx-auto mb-8">
        <!-- Breadcrumb / Back -->
        <a routerLink="/admin-dashboard"
            class="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-gray-800 transition mb-4 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="m15 18-6-6 6-6" />
            </svg>
            Back to Dashboard
        </a>

        <div class="flex flex-col md:flex-row justify-between items-start md:items-end gap-4">
            <div>
                <h1 class="text-3xl font-extrabold text-gray-900 tracking-tight">Top Performing Customers</h1>
            </div>


        </div>
    </div>

    <!-- Main Card -->
    <div
        class="max-w-7xl mx-auto bg-white rounded-3xl shadow-xl shadow-gray-100/50 border border-gray-100 overflow-hidden">

        <div class="overflow-x-auto">
            <table class="w-full text-left border-collapse">
                <thead>
                    <tr
                        class="bg-gray-50/50 border-b border-gray-100 text-[10px] uppercase tracking-wider text-gray-500 font-semibold">
                        <th class="px-4 py-5 text-center w-12">Rank</th>
                        <th class="px-4 py-5">Customer Profile</th>
                        <th class="px-4 py-5 text-center">Segment</th>
                        <th class="px-4 py-5 text-right bg-blue-50/30">Total (₹)</th>
                        <th class="px-4 py-5 text-right bg-green-50/30">Paid (₹)</th>
                        <th class="px-4 py-5 text-right bg-red-50/30">Due (₹)</th>
                        <th class="px-4 py-5 text-right bg-blue-50/50">Total Metal</th>
                        <th class="px-4 py-5 text-right bg-green-50/50">Recv Metal</th>
                        <th class="px-4 py-5 text-right bg-orange-50/50">Due Metal</th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-50">


                    <tr *ngFor="let customer of topTenCustomers"
                        class="group hover:bg-gray-50 transition-colors duration-200">
                        <!-- Rank Column -->
                        <td class="px-4 py-4 text-center">
                            <div class="flex justify-center">
                                <span *ngIf="customer.rank === 1"
                                    class="w-7 h-7 flex items-center justify-center bg-yellow-100 text-yellow-700 rounded-full font-bold shadow-sm border border-yellow-200 text-xs">1</span>
                                <span *ngIf="customer.rank === 2"
                                    class="w-7 h-7 flex items-center justify-center bg-slate-100 text-slate-700 rounded-full font-bold shadow-sm border border-slate-200 text-xs">2</span>
                                <span *ngIf="customer.rank === 3"
                                    class="w-7 h-7 flex items-center justify-center bg-orange-50 text-orange-800 rounded-full font-bold shadow-sm border border-orange-200 text-xs">3</span>
                                <span *ngIf="customer.rank > 3"
                                    class="text-gray-400 font-medium font-mono text-xs">#{{customer.rank}}</span>
                            </div>
                        </td>

                        <!-- Name & Branch -->
                        <td class="px-4 py-4" routerLink="/kcustomer-dashboard/{{customer.id}}">
                            <div class="flex items-center gap-3">
                                <div
                                    [class]="'w-8 h-8 rounded-full flex items-center justify-center text-[10px] font-bold ' + customer.color">
                                    {{ customer.initials }}
                                </div>
                                <div class="max-w-[150px]">
                                    <p
                                        class="font-bold text-gray-800 group-hover:text-indigo-600 transition-colors text-xs truncate">
                                        {{ customer.name }}</p>
                                    <p class="text-[10px] text-gray-400 mt-0.5 flex items-center gap-1">
                                        {{ customer.branch }}
                                    </p>
                                </div>
                            </div>
                        </td>

                        <!-- Segment Type -->
                        <td class="px-4 py-4 text-center">
                            <span [ngClass]="{
                                'bg-purple-50 text-purple-700 border-purple-100': customer.type === 'Wholesale',
                                'bg-blue-50 text-blue-700 border-blue-100': customer.type === 'Retail',
                                'bg-gray-100 text-gray-700 border-gray-200': customer.type === 'Corporate'
                            }" class="px-2 py-0.5 rounded-full text-[10px] font-semibold border">
                                {{ customer.type }}
                            </span>
                        </td>

                        <!-- Financials -->
                        <td class="px-4 py-4 text-right font-mono text-xs text-blue-700 font-semibold">₹{{
                            (customer.paidAmount + customer.dueAmount) | number:'1.0-0' }}</td>
                        <td class="px-4 py-4 text-right font-mono text-xs text-green-700 font-semibold">₹{{
                            customer.paidAmount | number:'1.0-0' }}</td>
                        <td class="px-4 py-4 text-right font-mono text-xs text-red-600 font-bold">₹{{ customer.dueAmount
                            | number:'1.0-0' }}</td>

                        <!-- Metal Details -->
                        <td class="px-4 py-4 text-right font-mono text-xs text-blue-800">{{ customer.metalBilled |
                            number:'1.3-3' }}g</td>
                        <td class="px-4 py-4 text-right font-mono text-xs text-green-800">{{ customer.metalReceived |
                            number:'1.3-3' }}g</td>
                        <td class="px-4 py-4 text-right font-mono text-xs text-orange-700 font-bold">{{
                            customer.metalDue | number:'1.3-3' }}g</td>


                    </tr>

                </tbody>
            </table>
        </div>

        <!-- Footer -->
        <div class="bg-gray-50 px-6 py-4 border-t border-gray-100 flex justify-between items-center text-sm">
            <span class="text-gray-500">Showing 1 to 10 of top active customers</span>
            <div class="flex gap-1">
                <button
                    class="w-8 h-8 flex items-center justify-center rounded border border-gray-200 bg-white text-gray-400 cursor-not-allowed">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7">
                        </path>
                    </svg>
                </button>
                <button
                    class="w-8 h-8 flex items-center justify-center rounded border border-gray-200 bg-white text-gray-600 hover:bg-gray-50">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>